import * as types from "./types";

import { 
    postDeliveryAxios,
    getDeliveryListAxios,
    getDeliveryIDAxios,
    putDeliveryAxios,
    deleteDeliveryAxios,
    putDeliveryStatusAxios,
    postDeliveryItemAxios,
    getDeliveryItemListAxios,
    getDeliveryItemIDAxios,
    putDeliveryItemAxios,
    deleteDeliveryItemAxios,
    putDeliveryItemStatusAxios,
    postDeliveryItemsAxios,
    getDeliverySignatureIDAxios,
    postDeliverySignatureAxios

} from "./services";

export async function getDeliveryListAction({commit}, id) {
    commit(types.LOADING_DELIVERY, true);
    try {
        const {data} = await getDeliveryListAxios(id);
        commit(types.GET_DELIVERY_LIST, data.result);
    }
    catch(e) {
        console.log(e);
    }
    commit(types.LOADING_DELIVERY, false);
}

export async function deleteDeliveryAction({commit}, payload) {
    commit(types.LOADING_DELIVERY, true);
    try {
        await deleteDeliveryAxios(payload);
        commit(types.REMOVE_DELIVERY, payload);
    }
    catch(e) {
        console.log(e);
    }
    commit(types.LOADING_DELIVERY, false);
}

export async function deleteDeliveryItemAction({commit}, payload) {
    commit(types.LOADING_DELIVERY, true);
    try {
        await deleteDeliveryItemAxios(payload);
        commit(types.REMOVE_DELIVERY_ITEM, payload);
    }
    catch(e) {
        console.log(e);
    }
    commit(types.LOADING_DELIVERY, false);
}

// export async function addDeliveryAction({commit}, payload) {
//     commit(types.LOADING_DELIVERY, true);
//     try {
//         const {data} = await postDeliveryAxios(payload);
//         payload.id = data.result.id;
//         commit(types.ADD_DELIVERY, payload);
//     }
//     catch(e) {
//         console.log(e);
//     }
//     commit(types.LOADING_DELIVERY, false);
// }

export async function addDeliveryAction({commit}, payload) {
    commit(types.LOADING_DELIVERY, true);
    try {
        const {data} = await postDeliveryAxios(payload);
        payload.id = data.result.id;
        commit(types.ADD_DELIVERY, payload);
        return data;
    }
    catch(e) {
        console.log(e);
    }
    finally {
        commit(types.LOADING_DELIVERY, false);
    }
}

export async function updateDeliveryAction({commit}, payload) {
    commit(types.LOADING_DELIVERY, true);
    try {
        await putDeliveryAxios(payload);        
        commit(types.UPDATE_DELIVERY, payload);
    }
    catch(e) {
        throw e;
    }
    finally{
        commit(types.LOADING_DELIVERY, false);
    }
}

export async function getDeliveryByIDAction({commit}, payload) {
    commit(types.LOADING_DELIVERY, true);
    try {
        const {data} = await getDeliveryIDAxios(payload);
        commit(types.GET_DELIVERYBYID, data.result);
    }
    catch(e) {
        console.log(e);
    }
    commit(types.LOADING_DELIVERY, false);
}

export async function getDeliveryItemListAction({commit}, id) {
    commit(types.LOADING_DELIVERY, true);
    try {
        const { data } = await getDeliveryItemListAxios(id);
        commit(types.GET_DELIVERY_ITEM_LIST, data.result);
    }
    catch(e) {
        console.log(e);
        commit(types.GET_DELIVERY_ITEM_LIST, []);
    }
    commit(types.LOADING_DELIVERY, false);
}

export async function addDeliveryItemAction({commit}, payload) {
    commit(types.LOADING_DELIVERY, true);
    try {
        const {data} = await postDeliveryItemAxios(payload);
        payload.id = data.result.id;
        commit(types.ADD_DELIVERY_ITEM, payload);
        return data;
    }
    catch(e) {
        console.log(e);
    }
    finally {
        commit(types.LOADING_DELIVERY, false);
    }
}

export async function addMultipleDeliveryItemAction({commit}, payload) {
    commit(types.LOADING_DELIVERY, true);
    try {
        const {data} = await postDeliveryItemsAxios(payload);
        payload.id = data.result.id;
        commit(types.ADD_DELIVERY_ITEM, payload);
        return data;
    }
    catch(e) {
        console.log(e);
    }
    finally {
        commit(types.LOADING_DELIVERY, false);
    }
}

export async function updateDeliveryItemAction({commit}, payload) {
    commit(types.LOADING_DELIVERY, true);
    try {
        await putDeliveryItemAxios(payload);        
        commit(types.UPDATE_DELIVERY_ITEM, payload);
    }
    catch(e) {
        throw e;
    }
    finally{
        commit(types.LOADING_DELIVERY, false);
    }
}

// export async function updateDeliveryItemStatusAction({commit}, payload) {
//     commit(types.LOADING_DELIVERY, true);
//     try {
//         await putDeliveryItemStatusAxios(payload);        
//         commit(types.UPDATE_DELIVERY_ITEM_STATUS, payload);
//     }
//     catch(e) {
//         throw e;
//     }
//     finally{
//         commit(types.LOADING_DELIVERY, false);
//     }
// }
export async function updateDeliveryItemStatusAction({ commit }, payload) {
    commit(types.LOADING_DELIVERY, true);
    try {
        console.log("statuspayload", payload);
        await putDeliveryItemStatusAxios(payload.id, payload);        
        commit(types.UPDATE_DELIVERY_ITEM_STATUS, payload);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_DELIVERY, false);
    }
}

export async function getDeliverySignatureByIDAction({commit}, id) {
    commit(types.LOADING_DELIVERY, true);
    try {
        const {data} = await getDeliverySignatureIDAxios(id);
        commit(types.GET_DELIVERYBYID_SIGNATURE, data.result);
        return data.result;
    }
    catch(e) {
        console.log(e);
        commit(types.GET_DELIVERYBYID_SIGNATURE, []);
    }
    commit(types.LOADING_DELIVERY, false);
}

export async function addDeliverySignatureAction({commit}, payload) {
    commit(types.LOADING_DELIVERY, true);
    try {
        const {data} = await postDeliverySignatureAxios(payload);
        payload.id = data.result.id;
        commit(types.ADD_DELIVERY_SIGNATURE, payload);
        return data;
    }
    catch(e) {
        console.log(e);
    }
    finally {
        commit(types.LOADING_DELIVERY, false);
    }
}